import React, { useState, useEffect } from 'react';
import './HbpCaseModal.css';
import * as Yup from 'yup';
import Form from '../../form/components/Form/Form';
import FormField from '../../form/components/FormField/FormField';
import Button from '../../form/components/Button/Button';
import ErrorMessage from '../../form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { FaCloudUploadAlt, FaTrashAlt } from  'react-icons/fa';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import ProgressBar from '../../Progress/Progress';
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs, addDoc, getDoc, updateDoc, serverTimestamp   } from "firebase/firestore"; 

import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
    patient_phone: null,
    gender: 'none',

}

const override = {
    marginTop: '20px'
  };


function HbpCaseModal({ onClose, onContentAdded } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    const [user] = useAuthState(auth);
    const [gender, setGender] = useState('');

    const [description, setDescription] = useState("");


    const validationSchema = Yup.object().shape({
        patient_phone: Yup.string().min(9, 'Must be at least  9 digits').max(9, 'Must be 9 digits').required('Phone is required'),
    })

    const createNewPatient = async (data: any) => {
        const patientCollectionRef = collection(db, "Patients");
        try {
          const res = await addDoc(patientCollectionRef, {
            createdAt: serverTimestamp(),
            displayName: data.name,
            email: "",
            gender: data.gender,
            phoneNumber: data.phone,
            dob: data.dob,
            is_verified: false,
          });
    
          await updateDoc(res, { uid: res.id });
          
        //   console.log('RETURNNG: ', res.id);
          return res.id;
        } catch (e) {
          console.error("Error creating and updating patient document ", e);
          return null;
        }
      };
    
    const handleSubmitData = async (values: any) => {
            // console.log('VALS:  ',  values);
            setLoading(true);
            const q = query(collection(db, "Patients"), where("phoneNumber", "==", `+237${values?.patient_phone}`));
            const querySnapshot = await getDocs(q);
            
            if(querySnapshot.size > 0) {
                // console.log('EXIST: ', querySnapshot.docs[0].id)å
                //IF PATIENT ALRREADY EXIST THEN THERE'S A CHANCE THEY MIGHT HAVE A CASE SO CHECK
                const q2 = query(collection(db, "Cases"), 
                where("patient_uid", "==", querySnapshot.docs[0].id),
                where("category", "==", "Blood Pressure Tracking"));
                const querySnapshot2 = await getDocs(q2);
                
                if(querySnapshot2.size > 0) {
                  //Patient already have a case
                  toast.error(`Patient has an existing HBP case with CODE: ${querySnapshot2.docs[0].data()?.CID}`, {
                    pauseOnHover: false,
                    closeOnClick: true,
                  });
                  setLoading(true);
                }else {
                  createNewCase({ ...values, patient_uid: querySnapshot.docs[0].id });
                }
              
            }else {
                const newPatientUid = await createNewPatient({
                    name: values.patient_name,
                    dob: values.patient_dob,
                    gender: gender,
                    phone: `+237${values.patient_phone}`,
                  });
                //   console.log('NEW: ', newPatientUid)
                  createNewCase({ ...values, patient_uid: newPatientUid });
            }
    }

    const createNewCase = async (data: any) => {
        const caseCollectionRef = collection(db, "Cases");
        // Generate random UID for the new document
        const currentDate = moment();
        const day = currentDate.date();
        const month = currentDate.month() + 1; 
        const year = currentDate.year();
        try {
          const res = await addDoc(caseCollectionRef, {
            category: "Blood Pressure Tracking",
            createdAt: Date.now(),
            doctor_uid: null,
            is_case_resolved: false,
            label: "HBP",
            subscription_id: null,
            subscription_status: false,
            patient_uid: data?.patient_uid,
            year: year,
            // description: description
          });
          
          // console.log('CASE CREATED: ', res.id);

          setLoading(false);
          toast.success("Case document created successfully", {
            pauseOnHover: false,
            closeOnClick: true,
          });
          onContentAdded();
          onClose();
        } catch (e) {
          // console.error("Error creating and updating patient document ", e);
          setLoading(false);
          toast.error("Error creating new case", {
            pauseOnHover: false,
            closeOnClick: true,
          });
          // return null
        }
      };



    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="reports-modal">
                <div className='modal-head'>
                    <p className="modal-title">Hbp Case Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitData}
                    validationSchema={validationSchema}
                >
    

                        <p className="label-text">Patient's Name: </p>
                        <FormField
                            name="patient_name"
                            type="text"
                            placeholder="Patient Name"
                        />


                <p className="label-text">
                      Gender:{" "}
                    </p>
                    <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setGender(e.target.value);
                      }}
                      className="select-field-modal"
                    >
                      <option value="" selected={true}>
                        None
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>

            
                    <p className="label-text">Patient Phone: </p>
                    <FormField
                      name="patient_phone"
                      type="number"
                      placeholder="Phone Number"
                    />

                <p className="label-text">Date of Birth: </p>
                    <FormField
                      name="patient_dob"
                      type="date"
                      placeholder="Date of Birth"
                    />

                {/* <p className="label-text">Description: </p>
                    <textarea
                      rows={8}
                      onChange={(e: any) => {
                        setDescription(e.target.value);
                      }}
                      value={description}
                      className="textarea"
                    ></textarea> */}

                      {!loading && <Button isOutLined={true} isFullWidth={false} title="SUBMIT DATA"/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default HbpCaseModal;

